import { useQuery } from '@tanstack/react-query';
import { fetchEventDetails } from '../api/eventDetailsApi';

export const eventDetailsQueryKey = (eventCode: string | undefined, accountCode: string | undefined) =>
  ['event-details', eventCode, accountCode] as const;

export function useEventDetails(eventCode: string | undefined, accountCode: string | undefined) {
  return useQuery({
    queryKey: eventDetailsQueryKey(eventCode, accountCode),
    queryFn: () => fetchEventDetails({ eventCode: eventCode!, accountCode: accountCode! }),
    enabled: !!eventCode && !!accountCode,
  });
}
